import { useTranslation } from 'react-i18next'

import { EricActivityTable } from '@/components/admin/EricActivityTable'

/**
 * Eric activity admin viewer — every inbound member-to-Eric request
 * (audit-logged in `assistant_requests`), newest first. Mira/Emil's
 * window into what Eric got asked, what tools fired, what reply went
 * out, and any errors captured by the orchestrator.
 *
 * Cross-tenant feed; for a single-tenant view see the Eric activity
 * tab on /admin/tenants/:id which mounts the same table component
 * with `shopId` set.
 */

export function AdminEricActivity() {
  const { t } = useTranslation('admin')

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">
          {t('eric_activity.title')}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('eric_activity.subtitle')}
        </p>
      </div>

      <EricActivityTable
        showFilters={true}
        queryKeyPrefix="admin.eric-activity.cross-tenant"
      />
    </div>
  )
}
